import { MONTHS } from '@src/constants';
import RoundedButton from '@features/ui/components/calendars/RoundedButton.tsx';
import { format } from 'date-fns';

interface Props {
  currentMonth: number;
  clickMonth: (month: number) => void;
}

export const Months = (props: Props) => {
  const { currentMonth, clickMonth } = props;

  return (
    <div className="w-full grid grid-cols-2 gap-2 mt-2">
      {MONTHS.map((item) => (
        <RoundedButton
          key={item}
          active={currentMonth === item}
          padding="py-3"
          onClick={() => {
            clickMonth(item);
          }}
        >
          {format(new Date(2022, item - 1, 1), 'MMMM')}
        </RoundedButton>
      ))}
    </div>
  );
};
